<mat-sidenav-content style="margin-left: 0px;">
  <div [@slideInOut]="animationState" class="sidenav surface-50">
    <div class="sidenav-title">
      <div class="flex surface-50 justify-content-between p-2">
        <div class="flex">
          <div #refHeader>
            <ng-content select="[title]"></ng-content>
          </div>
          <ng-container *ngIf="!refHeader.childElementCount">
            <span class="text-xs font-medium uppercase">
              {{ title }}
            </span>
          </ng-container>
        </div>
        <div *ngIf="closable" class="flex">
          <mat-icon
            (click)="sidenavService.popContent()"
            class="text-base cursor-pointer material-symbols-outlined"
            inline
          >
            close
          </mat-icon>
        </div>
      </div>
    </div>
    <ng-content select="[header]"></ng-content>
    <div [class]="'sidenav-content m-1 border-round bg-white border-1 border-200 p-'+padding">
      <ng-content></ng-content>
    </div>
    <div class="sidenav-footer p-2">
      <ng-content select="[footer]"></ng-content>
    </div>
  </div>
</mat-sidenav-content>
